import script from "./PresenceHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PresenceHome.vue?vue&type=script&setup=true&lang=js"

import "./PresenceHome.vue?vue&type=style&index=0&id=512f2676&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512f2676"]])

export default __exports__